import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { User } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useCurrentUser = () => {
  const fetchWithAuth = useFetchWithAuth()

  const getCurrentUser: QueryFunction<User> = async () => {
    try {
      const res = (await fetchWithAuth(`${URL}/auth/me`, {
        method: 'GET',
      })) as User
      return res
    } catch (error) {
      console.log('Error fetching current user:', error)
      // Let the error propagate so React Query can handle it
      throw error
    }
  }

  return useQuery({
    queryKey: ['currentUser'] as const,
    queryFn: getCurrentUser,
    retry: false, // don't retry on 401s
    staleTime: 5 * 60 * 1000, // consider data fresh for 5 minutes
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}
